import React, { useContext, useEffect, useState } from 'react';
import { MdCheckCircle, MdError } from 'react-icons/md';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row
} from 'reactstrap';
import { Loader } from '../../components/misc.js';
import ActionContext from "../../contexts/ActionContext";
import {
  createEntry,
  NetworkErrorHandler,
  updateEntry,
} from '../../utils/dataGenerator';
import NumberFormat from 'react-number-format';
import Select from 'react-select';

const VirtualCardForm = props => {
  const { user, card, onSuccess } = props;
  const actionContext = useContext(ActionContext);
  const isEditing = !!card;

  const initPayload = isEditing ? {
    status: 'Active',
    ...card
  } : {
    user: user._id,
    cardHolderName: `${user.first_name} ${user.last_name}`,
    cardNumber: '',
    cvc: '',
    expiryDate: '',
    status: 'Active',
    type: 'Virtual',
    currency: user.displayCurrency || 'USD',
  };

  const [payload, setPayload] = useState(initPayload);
  const [state, setState] = useState({
    isLoading: false,
  });

  useEffect(() => {
    setPayload(initPayload);
  }, [card]);

  const validate = e => {
    try {
      e.preventDefault();
      if (!payload.cardNumber) throw Error('Please enter a card number');
      if (!payload.cvc) throw Error('Please enter a CVC');
      if (!payload.expiryDate) throw Error('Please enter an expiry date');
      if (!payload.cardHolderName) throw Error('Please enter card holder name');

      submitForm();
    } catch (error) {
      actionContext.showNotification(
        <div className="align-center">
          <MdError style={{ fontSize: 20, color: 'red' }} />
          &nbsp;{NetworkErrorHandler(error)}
        </div>,
        { type: 'error' },
      );
    }
  };

  const submitForm = () => {
    setState({ ...state, isLoading: true });
    const operation = isEditing ? updateEntry : createEntry;
    const url = isEditing ? `cards/${card._id}` : `cards`;

    operation(url, payload, (res, err) => {
      setState({ ...state, isLoading: false });
      if (!err) {
        // actionContext.showNotification(
        //   <div className="align-center">
        //     <MdCheckCircle style={{ fontSize: 20, color: 'green' }} />
        //     &nbsp;Virtual Card {isEditing ? 'Updated' : 'Created'}
        //   </div>,
        //   { type: 'success' },
        // );
        if (onSuccess) onSuccess();
      } else {
        actionContext.showNotification(
          <div className="align-center">
            <MdError style={{ fontSize: 20, color: 'red' }} />
            &nbsp;{NetworkErrorHandler(err)}
          </div>,
          { type: 'error' },
        );
      }
    });
  };

  return (
    <Form onSubmit={validate}>
      <div className="p-3">
        <h6 className="stretched-text-sm mb-4 grey-text">VIRTUAL CARD DETAILS</h6>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="stretched-text-xs">Card Number</Label>
              <NumberFormat
                format="#### #### #### ####"
                placeholder="0000 0000 0000 0000"
                className="form-control"
                value={payload.cardNumber}
                onValueChange={(values) => {
                  const { value } = values;
                  setPayload({ ...payload, cardNumber: value });
                }}
                disabled={state.isLoading}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="stretched-text-xs">Card Holder Name</Label>
              <Input
                value={payload.cardHolderName}
                disabled={state.isLoading}
                className="stretched-text-xs"
                onChange={e => setPayload({ ...payload, cardHolderName: e.target.value })}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label className="stretched-text-xs">Expiry Date</Label>
                  <NumberFormat
                    format="##/##"
                    placeholder="MM/YY"
                    mask={['M', 'M', 'Y', 'Y']}
                    className="form-control"
                    value={payload.expiryDate}
                    onValueChange={(values) => {
                      const { value } = values;
                      setPayload({ ...payload, expiryDate: value });
                    }}
                    disabled={state.isLoading}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label className="stretched-text-xs">CVC</Label>
                  <NumberFormat
                    format="###"
                    placeholder="000"
                    className="form-control"
                    value={payload.cvc}
                    onValueChange={(values) => {
                      const { value } = values;
                      setPayload({ ...payload, cvc: value });
                    }}
                    disabled={state.isLoading}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Col>
          <Col md={4}>
            <Label className="stretched-text-xs">Status</Label>
            <FormGroup>
              <Select
                options={[
                  {
                    value: 'Active',
                    label: 'Active',
                  },
                  {
                    value: 'Inactive',
                    label: 'Inactive',
                  },
                  {
                    value: 'Blocked',
                    label: 'Blocked',
                  }
                ]}
                className={`capitalize`}
                onChange={val =>
                  setPayload({ ...payload, status: val.value })
                }
                isSearchable={true}
                placeholder={
                  payload.status ? payload.status : 'Select Status'
                }
              />
            </FormGroup>
          </Col>
        </Row>
        <div className="align-right mt-3">
          {isEditing && (
            <Button
              color="link"
              className="text-muted mr-2"
              onClick={() => {
                if (onSuccess) onSuccess(); // Use onSuccess to trigger a refresh/reset in parent
              }}
            >
              Cancel / New Card
            </Button>
          )}
          {state.isLoading ? <Loader /> : (
            <Button color="dark" className="bg-orange border-0 px-4">
              {isEditing ? 'Update Card' : 'Create Card'}
            </Button>
          )}
        </div>
      </div>
    </Form>
  );
};

export default VirtualCardForm;
